(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bgm-discount-experience"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bgm-discount-experience')) {
    customElements.define('bgm-discount-experience', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.context !== 'product') return;
        this.scope = this.closest('section') || document;
        this.handleQuantityChange = () => requestAnimationFrame(() => this.updateTiers());
        if (!this.bindQuantityInput()) {
          this.quantityObserver = new MutationObserver(() => {
            if (!this.bindQuantityInput()) return;
            this.quantityObserver.disconnect();
          });
          this.quantityObserver.observe(this.scope, { childList: true, subtree: true });
        }
      }

      disconnectedCallback() {
        this.quantityObserver?.disconnect();
        if (this.scope && this.handleQuantityChange && this.quantityInput) {
          this.scope.removeEventListener('change', this.handleQuantityChange);
          this.scope.removeEventListener('click', this.handleQuantityChange);
        }
      }

      bindQuantityInput() {
        if (this.quantityInput) return true;
        this.quantityInput = this.scope.querySelector('quantity-input input[name="quantity"]');
        if (!this.quantityInput) return false;
        this.scope.addEventListener('change', this.handleQuantityChange);
        this.scope.addEventListener('click', this.handleQuantityChange);
        this.updateTiers();
        return true;
      }

      updateTiers() {
        const quantity = Number.parseInt(this.quantityInput?.value || '1', 10);
        const reached = [...this.querySelectorAll('[data-threshold]')]
          .filter((tier) => quantity >= Number.parseInt(tier.dataset.threshold, 10));
        this.querySelectorAll('[data-threshold]').forEach((tier) => {
          tier.classList.remove('is-reached', 'is-current');
        });
        reached.forEach((tier) => tier.classList.add('is-reached'));
        reached.at(-1)?.classList.add('is-current');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
